import { combineReducers } from "redux";
import {
  ORGS_REQUEST,
  ORGS_SUCCESS,
  ORGS_FAILURE,
  OPTIONS_REQUEST,
  OPTIONS_SUCCESS,
  OPTIONS_FAILURE,
  SUMMARY_REQUEST,
  SUMMARY_SUCCESS,
  SUMMARY_FAILURE,
  SET_FILTER,
  SET_ME,
} from "./constants";

// Every value the dashboard can be scoped by. Blank string = "not set" (the
// backend treats absent/blank params as unscoped). Keys match the query params
// the summary endpoints read.
export const emptyFilters = {
  org_id: "",
  location_id: "",
  department_id: "",
  event_id: "",
  vasana_type: "",
  age_min: "",
  age_max: "",
  date_from: "",
  date_to: "",
};

const optionsInitial = { locations: [], departments: [], events: [], loading: false, error: null };

const uiInitial = { filters: emptyFilters, options: optionsInitial };

const ui = (state = uiInitial, action) => {
  switch (action.type) {
    case SET_FILTER: {
      const filters = { ...state.filters, ...action.payload };
      // Cascading resets: changing a parent scope invalidates its children, whose
      // option lists (and thus any prior selection) no longer apply.
      if ("org_id" in action.payload) {
        filters.location_id = "";
        filters.department_id = "";
        filters.event_id = "";
      }
      if ("location_id" in action.payload) {
        filters.department_id = "";
        filters.event_id = "";
      }
      if ("department_id" in action.payload) {
        filters.event_id = "";
      }
      return { ...state, filters };
    }
    case OPTIONS_REQUEST:
      return { ...state, options: { ...state.options, loading: true, error: null } };
    case OPTIONS_SUCCESS:
      return {
        ...state,
        options: {
          loading: false,
          error: null,
          locations: action.payload.locations || [],
          departments: action.payload.departments || [],
          events: action.payload.events || [],
        },
      };
    case OPTIONS_FAILURE:
      return { ...state, options: { ...optionsInitial, error: action.payload } };
    default:
      return state;
  }
};

const orgsInitial = { loading: false, error: null, list: [] };
const organizations = (state = orgsInitial, action) => {
  switch (action.type) {
    case ORGS_REQUEST:
      return { ...state, loading: true, error: null };
    case ORGS_SUCCESS:
      return { ...state, loading: false, list: action.payload };
    case ORGS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const summaryInitial = {
  loading: false,
  error: null,
  distribution: [],
  demographics: { population: null, age: [], gender: [] },
  assessmentScores: [],
  deepDive: [],
  typeIndex: null,
  required: null,
};
const summary = (state = summaryInitial, action) => {
  switch (action.type) {
    case SUMMARY_REQUEST:
      return { ...state, loading: true, error: null };
    case SUMMARY_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case SUMMARY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// The signed-in admin, from GET /api/me. `role` is "platform_admin" (full access,
// every filter) or "org_admin" (scoped to one org → the Organization filter is
// hidden and locked to `organization_id`). `loaded` guards the one-time setup that
// depends on knowing the role.
const meInitial = {
  loaded: false,
  role: null,
  organization_id: null,
  organization_name: null,
};
const me = (state = meInitial, action) => {
  switch (action.type) {
    case SET_ME:
      return {
        loaded: true,
        role: action.payload?.role ?? null,
        organization_id: action.payload?.organization_id ?? null,
        organization_name: action.payload?.organization_name ?? null,
      };
    default:
      return state;
  }
};

export default combineReducers({ ui, organizations, summary, me });
